import { UnautherizedScreen } from "pages/error-screens/UnautherizedScreen";
import { createContext, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
// @ts-ignore
export const PermissionContext = createContext<any>();

export const PermissionProvider = ({ children }: any) => {
  const [isUnauthorized, setIsUnauthorized] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (isUnauthorized) {
      setIsUnauthorized(false);
    }
  }, [location]);

  return (
    <PermissionContext.Provider value={{ isUnauthorized, setIsUnauthorized }}>
      {isUnauthorized ? <UnautherizedScreen /> : children}
    </PermissionContext.Provider>
  );
};

export const useUnautherizeAccess = () => {
  const { isUnauthorized, setIsUnauthorized } = useContext(PermissionContext);
  return setIsUnauthorized;
};
